var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.25H28.5C30.0913 11.25 31.6174 11.8821 32.7426 13.0074C33.8679 14.1326 34.5 15.6587 34.5 17.25V35.25C34.5 35.6478 34.342 36.0294 34.0607 36.3107C33.7794 36.592 33.3978 36.75 33 36.75H9C7.4087 36.75 5.88258 36.1179 4.75736 34.9926C3.63214 33.8674 3 32.3413 3 30.75V12.75C3 12.3522 3.15804 11.9706 3.43934 11.6893C3.72064 11.408 4.10218 11.25 4.5 11.25V11.25Z",
    stroke: "#101010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 21L45 15V33L34.5 27",
    stroke: "#101010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload-video.cedbedc25780a934b5b4f5ae06b619a4.svg";
export { ForwardRef as ReactComponent };